<template>
  <!-- 顶部导航 -->
  <header class="header" :class="{ scroll: isScroll }">
    <div class="header-left">
      <div class="logo">
        <img :src="isScroll ? require('@/assets/透明logo.png') : require('@/assets/透明logo.png')" class="logo-img"
          alt="来秋">
      </div>

      <nav class="nav">
        <div class="nav-item active">首页</div>

        <!-- <div class="nav-item has-dropdown">
          <span>社区</span>
          <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M36 18L24 30L12 18" stroke="#4d555d" stroke-width="3" stroke-linecap="butt"
              stroke-linejoin="round"></path>
          </svg>
          <div class="dropdown">
            <div class="dropdown-item">私域知识店铺</div>
            <div class="dropdown-item">企微SCRM</div>
            <div class="dropdown-item">AI智能体</div>
            <div class="dropdown-item">公域获客工具</div>
            <div class="dropdown-item">陪跑孵化</div>
          </div>
        </div> -->

        <div class="nav-item">最新资讯</div>
        <div class="nav-item">关于我们</div>
      </nav>
    </div>

    <div class="header-right">
      <el-button class="teacher-login-btn" @click="goLogin">
        前往登录
      </el-button>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// 滚动监听
const isScroll = ref(false)

const handleScroll = () => {
  isScroll.value = window.scrollY > 20
}

const goLogin = () => {
  window.open('https://user.lqaqiu.xyz', '_blank')
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  height: 70px;
  background: transparent;
  /* 初始透明 */
  box-shadow: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  transition: all 0.3s ease;
  /* 平滑动画 */

  /* 滚动后样式 */
  &.scroll {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 2px;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .logo-img {
    width: 150px;
    height: 80px;
    transform: scale(2.5);
    transition: transform 0.2s ease;
    object-fit: contain;
  }

  .nav {
    display: flex;
    align-items: center;
    gap: 32px;

    .nav-item {
      position: relative;
      cursor: pointer;
      color: #333;
      font-size: 16px;
      transition: color 0.2s;
      display: flex;
      align-items: center;
      gap: 4px;
      height: 70px;

      &.active {
        color: #4096ff;
        font-weight: 500;
      }

      &:hover {
        color: #4096ff;
      }

      svg {
        transition: transform 0.2s ease;
      }

      .dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        min-width: 180px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        padding: 10px 0;
        opacity: 0;
        visibility: hidden;
        transform: translateY(10px);
        transition: all 0.25s ease;
        z-index: 99;
      }

      .dropdown-item {
        padding: 10px 20px;
        font-size: 15px;
        color: #333;
        transition: all 0.2s;

        &:hover {
          background: #f5f8ff;
          color: #4096ff;
        }
      }

      &.has-dropdown:hover {
        .dropdown {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .teacher-login-btn {
    padding: 10px 24px;
    background: #4096ff;
    color: #fff;
    border: none;
    border-radius: 24px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    transition: background 0.2s;

    &:hover {
      background: #66b1ff;
    }
  }
}
</style>